import React, { Component } from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { Cookies } from 'react-cookie';
import {Link, Element} from 'react-scroll';
import {Helmet} from 'react-helmet';
import _ from 'lodash';

import LearnMore from '../../components/Forms/LearnMore';
import iconChecks from '../../assets/svg/icon-checks.svg';
import ReasonsResults from '../../components/Reasons/ReasonsResults';
import CustomerConnect from '../../components/CustomerConnect/CustomerConnect';
import ScrollButton from '../../components/Header/ScrollButton.jsx';
import * as ResultHelpers from '../../helpers/results';
import {encodeUrl} from '../../helpers/quiz';
import * as RouteHelpers from '../../helpers/routes';

class ResultsEssential extends Component {
  state = {
    fieldValues: {},
    data: {},
    plans: [],
    selectedPlan: [],
    loading: true,
    url: `${process.env.REACT_APP_API_URL}/plans/individual`,
    formResults: this.props.fieldValues,
    location: this.props.location,
    showModal: false,
    includeChildHealthPlus: false,
    mounted: false,
    headerHeight: 100,
    animateChangePrice: false,
    mobileChangeColumn: 'after',
    trackOnce: true
  };

  componentDidMount () {
    const p = _.clone(this.props);
    const cookies = new Cookies();

    if (cookies.get('CDPHP_myResults') && this.props.showResults) { // Check for cookie
      this.setState({ formResults: cookies.get('CDPHP_myResults') });
    }

    if (p.route !== 'quote') {
      const fieldValues = _.merge({}, p.quiz.fieldValues, {'ResultsType': 'ResultsEssential'});
      const resultString = encodeUrl(fieldValues);
      cookies.set('CDPHP_quoteString', resultString, { path: '/' });
      RouteHelpers.history.push('/quote/' + resultString);
    } else if (Object.keys(p.rest.quote).length === 0) {
      p.reducer({fieldValues: p.quiz.fieldValues, url: 'individual'});
      p.updateHeaderPhone('866-692-3747');
      p.toggleInQuiz(false);
      p.toggleInResults(true);
      p.updateResultsFooter(true, {
        'jdpower': 'true',
        'results': 'true'
      });
      p.updateResultsRatings(true, {
        'jdpower': 'true'
      });
      p.updateHeaderScroller(
        <ScrollButton
          text='Contact Me'
          scrollName='learnForm'
          scrollOpts={{
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -200
          }}
        />
      );
    }
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {rest, quiz} = p;
    const {fieldValues} = quiz;

    if (_.isObject(rest.quote) && Object.keys(rest.quote).length && state.trackOnce === true) {
      // set state once we have data from the server on the selected plan:
      ResultHelpers.sendAnalyticsOnQuote(fieldValues, rest);

      return {
        data: rest.quote.data,
        selectedPlan: rest.quote.selectedPlan,
        selectedPlanID: rest.quote.SelectedPlanId,
        formResults: fieldValues,
        loading: false,
        trackOnce: false
      };
    }

    return null; // if no state mutations are required at this time
  }

  componentWillUnmount () {
    this.setState({mounted: false});
  }

  // Create Cookie Here
  setCookie = (data) => {
    const cookies = new Cookies();
    cookies.set('CDPHP_myResults', data, { path: '/' });
  };

  childHealthPlusCheckbox = (e) => {
    let checked = e.target.checked;
    this.setState({
      includeChildHealthPlus: checked
    });
  };

  getHeaderHeight = (height) => {
    this.setState({headerHeight: height});
  };

  mobileChangeColumn = (id) => {
    this.setState({
      mobileChangeColumn: id
    });
  };

  render () {
    // Format Numbers
    const numberWithCommas = ResultHelpers.numberWithCommas;

    const result = _.clone(this.props.rest.quote.PlanEssential);

    // Set up
    let monthlyPremium = null;
    let oopmax = null;

    if (!_.isUndefined(result)) {
      monthlyPremium = result.Premium;
      oopmax = result.OopMax;
    }

    let oopMaxAmount = oopmax ? numberWithCommas(oopmax) : '';

    let loading;
    let showCHP;
    let familyType = this.props.quiz.fieldValues.FamilyType;
    let numberOfKids = this.props.quiz.fieldValues.KidsCount;
    let childLang = null;
    let heading = 'for you.';
    let area = 'Essential';
    // let title = 'Your CDPHP Essential Plan Quote';
    let LeadSource = 'funnel_consumer_quote_essential_plan';
    let calculateCHP = null;
    // let childLang02;
    let chpTotal = (numberOfKids * this.props.rest.quote.ChpCostPerChild);
    let chpMax = this.props.rest.quote.ChpSubsidizedMax;
    let monthlyCHP = null;
    if (this.state.loading) {
      loading = 'loading';
    }

    if (familyType === 'Couple' || familyType === 'CoupleChildren') {
      heading = <span className='break'>for you and your spouse.</span>;
    }

    if (familyType === 'CoupleChildren' || familyType === 'IndividualChildren') {
      if (numberOfKids > 0) {
        // heading = <span className='break'>for your family.</span>;
        if (numberOfKids === 1) {
          childLang = 'child is';
          // childLang02 = "child";
        } else {
          childLang = 'children are';
          // childLang02 = "children";
        }
        showCHP = <strong>Your {numberOfKids} {childLang} eligible for subsidized Child Health Plus:</strong>;
        area = 'EssentialCHP';
        // title = 'Your CDPHP Essential Plan & Child Health Plus Plan Quote';
        LeadSource = 'funnel_consumer_quote_essential_plan_and_chp';
      }
    }

    if (chpTotal < chpMax) {
      monthlyCHP = chpTotal;
    } else {
      monthlyCHP = chpMax;
    }

    if (showCHP) {
      calculateCHP = (<span> ${monthlyCHP}/month with no additional costs.<br /> Call <a href='tel:866-692-3747' className='tel'>866-692-3747</a> or <Link
        to='learnForm' spy smooth={'easeInOutQuart'}
        duration={800}
        offset={-100}>complete the form</Link> to learn more or enroll any time.</span>);
    }

    // Add to Monthly Premium
    if (this.state.includeChildHealthPlus) {
      if (chpTotal < chpMax) {
        monthlyPremium = monthlyPremium + chpTotal;
      } else {
        monthlyPremium = monthlyPremium + chpMax;
      }
    }

    // Monthly Premiums, split whole amount and decimals for display
    let monthlyDollars = '';
    let monthlyCents = '';

    if (monthlyPremium === 0) {
      monthlyDollars = '0';
      monthlyCents = '.00';
    } else {
      if (monthlyPremium) {
        const monthlyPremiumString = monthlyPremium.toFixed(2).toString();
        monthlyDollars = monthlyPremiumString.slice(0, -3);
        monthlyCents = monthlyPremiumString.slice(-3);
      }
    }

    // Send Location Through

    const cookies = new Cookies();
    let Loc = this.props.location;
    if (cookies.get('CDPHP_myResults')) {
      Loc = cookies.get('CDPHP_myResults').Location;
    }

    return (

      <div className={'single ' + loading}>
        <Helmet>
          <title>Your CDPHP Essential Plan Quote</title>
        </Helmet>
        {(!_.isUndefined(showCHP) && !_.isUndefined(result)) &&
          <section className='chp-callout essentialOnly'>
            <div className='wrap sm'>
              <div className='container'>
                {showCHP}{calculateCHP}
              </div>
            </div>
          </section> }

        {!_.isUndefined(result) && <section id='intro' className='essential'>
          <div className='wrap'>
            <h1>We have just the plan&nbsp;{heading}</h1>
            <h3>Based on your answers, we recommend <strong>{result.PlanName}</strong>.</h3>
          </div>
        </section>}

        {!_.isUndefined(result) && <section>
          <div className='wrap sm'>
            <div className='container'>
              <img src={iconChecks} className='checks' alt='' />
              <ul className='bullets'>
                <li>{result.PlanDescriptor1}</li>
                <li>{result.PlanDescriptor2}</li>
                <li>{result.PlanDescriptor3}</li>
                {result.PlanDescriptor4 ? <li>{result.PlanDescriptor4}</li> : null }
              </ul>
              <div className='navigate essential-premium'>
                <div>
                  <h3>The <Tooltip title='This is your “Premium.” It’s the price you pay for ongoing insurance coverage.' arrow='true'><span className='helpTip'>monthly fee</span></Tooltip> is <strong>${numberWithCommas(monthlyDollars)}<sup>{monthlyCents}*</sup></strong> per adult.</h3>
                </div>
              </div>
            </div>
          </div>
        </section>}

        <ReasonsResults type='essential' search='https://findadoc.cdphp.com/?PlanType=Essential Plan' />

        <section>
          <div className='wrap sm'>
            <div className='container'>
              <div className='navigate expenses medicare-expenses'>
                <h4>You’re responsible for a portion of your medical bills.</h4>
              </div>
            </div>
          </div>
        </section>

        {!_.isUndefined(result) && <section>
          <div className='wrap sm'>
            <div className='results container'>
              <table>
                <thead>
                  <tr className='heading'>
                    <th className='item'><h4>Plan Benefits</h4></th>
                    <th className='after'><h4>You Pay<br /> This Portion</h4></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='item'><h5>Primary Care Visits</h5></td>
                    <td>You pay <strong>{result.PcpVisit}</strong></td>
                  </tr>
                  <tr className='alt'>
                    <td className='item'><h5>Specialist Doctor Visits</h5></td>
                    <td>You pay <strong>{result.SpecialistVisit}</strong></td>
                  </tr>
                  <tr>
                    <td className='item'><h5>Hospital Stays</h5></td>
                    <td>You pay <strong>{result.InpatientHospitalStays}</strong></td>
                  </tr>
                  <tr className='alt'>
                    <td className='item'><h5>Surgery</h5></td>
                    <td>You pay <strong>{result.Surgery}</strong></td>
                  </tr>
                  <tr>
                    <td className='item'><h5>Urgent Care</h5></td>
                    <td>You pay <strong>{result.UrgentCare}</strong></td>
                  </tr>
                  <tr className='alt'>
                    <td className='item'><h5>Emergency Room</h5></td>
                    <td>You pay <strong>{result.EmergencyRoom}</strong></td>
                  </tr>
                  <tr>
                    <td className='item'><Tooltip title='Pricing for prescription drugs is based on a variety of factors, but in general, generic and brand-name drugs that have a proven clinical advantage are typically less expensive, whereas experimental drugs, or those without a proven clinical advantage, tend to be more expensive.' arrow='true'><h5 className='helpTip'>Prescription Drugs</h5></Tooltip></td>
                    <td>You pay <strong>{result.Prescriptions}</strong></td>
                  </tr>
                  <tr className='alt'>
                    <td className='item'><h5>Eye Exams</h5></td>
                    <td>You pay <strong>{result.EyeExams}</strong></td>
                  </tr>
                  <tr>
                    <td className='item'><h5>Dental</h5></td>
                    <td>You pay <strong>{result.Dental}</strong></td>
                  </tr>

                </tbody>
              </table>
              <div className='navigate essential-oopmax'>
                <div>
                  <h4>Once you&rsquo;ve paid a total of <Tooltip title='This is your “Out of Pocket Maximum.” It’s the most you’ll have to pay for covered health services in a plan year.' arrow='true'><span className='helpTip'><strong className='price'>${oopMaxAmount}</strong> toward your bills</span></Tooltip>, CDPHP covers everything through the end of the year.</h4>
                  <p className='info text-center medicare-disclaimer'>Even in the event of a serious medical issue, you’ll never pay more than this in a calendar year—as long as you see the doctors and hospitals in our plan.</p>
                </div>
              </div>
            </div>
          </div>
        </section>}

        {!_.isUndefined(result) && <Element name='learnForm'>
          <LearnMore
            planName={result.PlanName}
            area={area}
            details={this.state.formResults}
            lastPlanId={result.PlanId}
            LeadSource={LeadSource}
            Location={Loc} />
        </Element>}

        <section className='contact'>
          <div className='wrap sm text-center'>
            <h5>We&rsquo;re here to help.</h5>
            <div>
              Call us at <a href='tel:866-692-3747' className='tel phoneswap'>866-692-3747</a>
              {Loc && Loc.loc && <CustomerConnect zip={Loc.loc.Zip} />}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ResultsEssential;



// WEBPACK FOOTER //
// ./src/containers/Results/ResultsEssential.jsx